<template>
  <div
    class="im-user-rating"
    v-bind:class="'im-user-rating_level_' + rating"
  >
    <a
      :href="href"
      target="_blank"
      v-bind:title="title + rating"
    >
      <div class="im-user-rating__stroke">
        <svg>
          <use xlink:href="#icon-avatar-rating"></use>
        </svg>
      </div>
      <div class="im-user-rating__bg">
        <svg>
          <use xlink:href="#icon-avatar-rating"></use>
        </svg>
      </div>
      <div class="im-user-rating__number">{{ rating }}</div>
    </a>
  </div>
</template>


<script>
  export default {
    name: 'UserRating',
    props: {
      rating: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        href: '/info/help/site/forums/o_statusakh_polzovateley_chto_oboznachayut_vse_eti_shchitochki.html',
        title: 'Привилегированный пользователь уровня '
      };
    }
  };
</script>

<style lang="scss">
  .im-user-rating {
    $root: &;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 20px;
    position: relative;

    &__stroke {
      svg {
        fill: #FFF;
        width: 18px;
        height: 20px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    &__bg {
      svg {
        width: 16px;
        height: 18px;
        position: absolute;
        top: 1px;
        left: 1px;
      }
    }

    &__number {
      position: relative;
      top: -0.5px;
      font-family: 'Roboto', sans-serif;
      font-size: 10px;
      font-weight: bold;
      line-height: 12px;
      color: #FFF;
    }

    @for $i from 1 through 20 {
      &_level_#{$i} {
        #{$root}__bg {
          svg {
            fill: url(#avatar-rating-#{$i});
          }
        }
      }
    }
  }
</style>